import React from 'react'
import Heading from '@react/react-spectrum/Heading'

export default function Title ({
    title
}) {
    return (
        <div className="adobe-easybake-nav-heading">
            <Heading className="adobe-easybake-nav-title" variant="subtitle1">{title}</Heading>
        </div>
    )
}
